




























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import {
  UserEntity,
  ParticipantListDTO,
  ParticipationLevelEnum,
} from '@/store/modules/projects/types/projects.types';
import AuditParticipantForm from '../components/AuditParticipantForm.vue';
import { RootState } from '@/store/store';
import { ToastProgrammatic as Toast } from 'buefy';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import {
  AuditSite,
  AuditDetail,
  DeleteAuditParticipantPayload,
} from '../../../store/modules/audits/types/audits.types';
import BaseDialog from '../../../components/base/BaseDialog.vue';
import Card from '@/components/Card.vue';
import DeleteModalBox from '../../../components/DeleteModalBox.vue';
import { ApiState } from '../../../store/types/general.types';
import { useUserEmail } from '@/utils/user.util';
import { getJBIUsername } from '@/jbi-shared/util/user.utils';
import { PacesParticipantRoles } from '@/jbi-shared/types/paces-project.types';

@Component({
  components: { Card },
})
export default class AuditParticipantTab extends Vue {
  @Prop({ default: true }) public editable!: boolean;
  @Prop() public auditDetail!: AuditDetail;
  @Prop() public projectOwner!: UserEntity;

  @State((state) => state.audits.auditSites)
  public auditSites!: AuditSite[];

  @State((state: RootState) => state.audits.participants)
  public auditParticipants!: ParticipantListDTO[];

  @State((state: RootState) => state.audits.apiState.deleteAuditParticipant)
  public deleteAuditParticipantState!: ApiState;

  @State((state: RootState) => state.audits.apiState.resendInvitation)
  public resendInvitationState!: ApiState;

  @State((state: RootState) => state.audits.apiState.createAuditParticipant)
  public createAuditParticipantState!: ApiState;

  @State((state: RootState) => state.audits.apiState.updateAuditParticipant)
  public updateAuditParticipantState!: ApiState;

  @State((state: RootState) => state.audits.apiState.getAuditSites)
  public getAuditSitesState!: ApiState;

  @State((state: RootState) => state.projects.participants)
  public projectParticipantList!: ParticipantListDTO[];

  @Action('audits/getParticipants')
  public getAuditParticipants!: (payload: {
    auditId: number;
    includeInvites: boolean;
  }) => void;

  @Action('audits/deleteAuditParticipant')
  public deleteAuditParticipant!: (
    payload: DeleteAuditParticipantPayload,
  ) => void;

  @Action('audits/resendInvitation')
  public resendInvitation!: (payload: {
    auditId: number;
    invitationId: number;
    auditParticipantId: number;
  }) => void;

  @Action('audits/getAuditSites')
  public getAuditSites!: (auditId: number) => void;

  @Action('projects/getProjectParticipants')
  public getProjectParticipants!: (payload: {
    projectId: number;
    includeInvites: boolean;
    includeAuditInvites: boolean;
  }) => void;

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  get auditId() {
    return +this.$route.params.auditId;
  }

  get sites() {
    if (!this.auditSites || !this.auditSites.length) {
      return [];
    }

    return this.auditSites.map(({ site }) => ({
      id: site.id,
      name: site.name,
      address: site.address,
      description: site.description,
    }));
  }

  public mounted() {
    this.getAuditSites(this.auditId);
    this.getAuditParticipants({ auditId: this.auditId, includeInvites: true });
    this.getProjectParticipants({
      projectId: this.auditDetail.project.id,
      includeInvites: true,
      includeAuditInvites: true,
    });
  }

  get participantData(): ParticipantListDTO[] {
    if (!this.auditParticipants) {
      return [];
    }

    return this.auditParticipants.filter(
      (participant) =>
        participant.participantRole !==
        PacesParticipantRoles.ProjectAdministrator,
    );
  }

  /**
   * As we may not have id for each participant.
   * As user could be invited participant OR invite accepted participant
   * using math random to generate UniqueKey for each participant/user of list
   */
  public participantKey(item: ParticipantListDTO): string {
    return item.participantRole + Math.floor(Math.random() * 999);
  }

  public getParticipantName(item: ParticipantListDTO) {
    if (item.userEmail === this.userEmail) {
      return 'You';
    } else if (item.participant) {
      return getJBIUsername(
        item.participant.user.email,
        item.participant.user.oicPayload,
      );
    } else {
      return item.userEmail;
    }
  }

  get projectAdminUsername(): string {
    if (this.projectOwner.email === this.userEmail) {
      return 'You';
    } else {
      return getJBIUsername(
        this.projectOwner.email,
        this.projectOwner.oicPayload,
      );
    }
  }

  // TODO: PAC-924 check on resend invite
  public invitationStatus(participant: any) {
    const invitation = participant.invitation || '';

    if (invitation.acceptedAt) {
      return 'Accepted';
    }

    if (new Date(invitation.expiredAt) <= new Date()) {
      return 'Expired';
    } else {
      return 'Pending';
    }
  }

  public handleResend(participant: ParticipantListDTO) {
    this.$buefy.modal.open({
      parent: this,
      component: BaseDialog,
      hasModalCard: true,
      trapFocus: true,
      props: {
        title: `Resend`,
        content: `Are you sure you want to resend invitation to this participant?`,
        confirmButtonText: 'Resend',
      },
      events: {
        confirm: () => {
          // TODO:PAC-924 - Resend invite: Commented out for temporary, need to be handle -->
          // if (
          //   this.auditSites.length &&
          //   participant
          // ) {
          //   // A audit participant can be associated with different invites under different sites,
          //   // If there is more than one project coordinator for the same audit
          //   // under different sites who have created them.
          //   // That's why we match the audit participant with the current logged in user's site.
          //   // So we get the invite specific to this audit.
          //   const userSite: Site = this.auditSites[0];
          //   const matchedAuditParticipantSite = participant.auditParticipantRoles[0].participantSites.find(
          //     (auditParticipantSite) =>
          //       auditParticipantSite.site.id === userSite.id,
          //   );
          //   this.resendInvitation({
          //     auditId: this.auditId,
          //     invitationId: matchedAuditParticipantSite.invite.id,
          //     auditParticipantId: participant.id,
          //   });
          // }
        },
      },
    });
  }

  public handleCreate() {
    const modal = this.$buefy.modal.open({
      parent: this,
      props: {
        isEdit: false,
        participant: null,
        sites: this.sites,
        projectOwnerEmail: this.projectOwner.email,
        participantsList: this.participantData,
        projectParticipantList: this.projectParticipantList,
      },
      component: AuditParticipantForm,
      hasModalCard: true,
      events: {
        close: () => {
          modal.close();
        },
      },
    });
  }

  public handleEdit(participant: ParticipantListDTO) {
    const modal = this.$buefy.modal.open({
      parent: this,
      props: {
        isEdit: true,
        participant,
        sites: this.sites,
        projectOwnerEmail: this.projectOwner.email,
        participantsList: this.participantData,
      },
      component: AuditParticipantForm,
      hasModalCard: true,
      events: {
        close: () => {
          modal.close();
        },
      },
    });
  }

  public async handleDelete(participant: ParticipantListDTO) {
    this.$buefy.modal.open({
      parent: this,
      component: DeleteModalBox,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: `Delete ${participant.userEmail}?`,
        modalContent: `${participant.userEmail} will no longer be able to access to this data collection period.`,
      },
      events: {
        confirm: () => {
          const siteIds: number[] = this.sites.map((site) => site.id);
          this.deleteAuditParticipant({
            email: participant.userEmail,
            assignedRole: participant.participantRole,
            assignedSiteIds: siteIds,
            level: ParticipationLevelEnum.Audit,
            auditId: this.auditId,
          });
        },
      },
    });
  }

  @Watch('getAuditSitesState.success')
  @isTruthy
  public onGetAuditSitesState(data: ApiState) {
    const auditSiteIds: number[] =
      this.auditSites.length > 0
        ? this.auditSites.map((auditSite) => auditSite.site.id)
        : [];
  }

  @Watch('deleteAuditParticipantState.success')
  @isTruthy
  public async onDeleteSuccess() {
    this.getAuditParticipants({ auditId: this.auditId, includeInvites: true });

    Toast.open({
      queue: true,
      type: 'is-dark',
      position: 'is-top',
      message: `Successful delete participant`,
    });
  }

  @Watch('resendInvitationState.success')
  @isTruthy
  public async onResendSuccess() {
    this.getAuditParticipants({ auditId: this.auditId, includeInvites: true });

    Toast.open({
      queue: true,
      type: 'is-dark',
      position: 'is-top',
      message: `Successful resend invitation to participant`,
    });
  }

  @Watch('createAuditParticipantState.success')
  @isTruthy
  public onCreateSuccess(): void {
    Toast.open({
      queue: true,
      type: 'is-dark',
      position: 'is-top',
      message: `Participant invited successfully`,
      duration: 3500,
    });
    this.getAuditParticipants({ auditId: this.auditId, includeInvites: true });
  }

  @Watch('updateAuditParticipantState.success')
  @isTruthy
  public updateSuccess(): void {
    Toast.open({
      queue: true,
      type: 'is-dark',
      position: 'is-top',
      message: `Participant updated successfully`,
      duration: 3500,
    });
    this.getAuditParticipants({ auditId: this.auditId, includeInvites: true });
  }
}
